
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    imageUrl: {
      type: String,
      default: undefined,
    },
  },
  setup(props) {
    return {
      props,
    };
  },
});
